import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, withCtx as _withCtx, isRef as _isRef, normalizeClass as _normalizeClass, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent } from "vue"

const _hoisted_1 = { class: "tw-px-10 tw-py-[40px] modal-add-user" }
const _hoisted_2 = { class: "tw-flex tw-items-start tw-flex-col tw-gap-[15px] headingWrapper tw-pb-[40px]" }
const _hoisted_3 = { class: "tw-text-[#211F58] tw-text-[22px] tw-not-italic tw-font-semibold tw-leading-[100%]" }
const _hoisted_4 = { class: "tw-text-[#231F20] tw-text-[15px] tw-not-italic tw-font-normal tw-leading-[145%]" }
const _hoisted_5 = { class: "sm-display-column-container tw-flex tw-justify-between tw-items-center tw-my-[20px]" }
const _hoisted_6 = { class: "field-title-container tw-whitespace-nowrap tw-min-w-[115px] tw-leading-[58px] tw-h-[58px] tw-text-[14px] tw-font-medium" }
const _hoisted_7 = /*#__PURE__*/_createElementVNode("span", { class: "tw-text-[#F7553C]" }, "*", -1)
const _hoisted_8 = { class: "field-content-container tw-flex tw-max-w-[520px] tw-w-[520px]" }
const _hoisted_9 = { class: "dropdown-container tw-flex-1 dropdown" }
const _hoisted_10 = { class: "sm-display-column-container tw-flex tw-justify-between tw-items-center tw-my-[20px]" }
const _hoisted_11 = {
  class: "field-title-container tw-whitespace-nowrap tw-min-w-[115px] tw-leading-[58px] tw-h-[58px] tw-text-[14px] tw-font-medium",
  "data-cy": "add-user-to-role-modal-select-user-title"
}
const _hoisted_12 = /*#__PURE__*/_createElementVNode("span", { class: "tw-text-[#F7553C]" }, "*", -1)
const _hoisted_13 = { class: "field-content-container tw-flex tw-max-w-[520px] tw-w-[520px]" }
const _hoisted_14 = { class: "dropdown-container tw-flex-1 dropdown" }
const _hoisted_15 = { class: "button-container tw-flex tw-flex-col tw-items-end tw-mt-[20px]" }
const _hoisted_16 = { class: "tw-flex tw-mb-[40px] tw-gap-[10px]" }
const _hoisted_17 = { class: "tw-text-[13px] tw-text-[#B7B7B7] tw-font-medium tw-leading-[28px]" }

import store from "../../../store";
import utilities, { getComponentUiText } from "../../../utils/utilities";
import { Ref, computed, onMounted, reactive, ref, watch } from "vue";

import Modal from "../../common/modal.vue";
import ModalHeader from "../../common/modalHeader.vue";
import CustomBDropDown from "../../common/customBDropDown.vue";
import CustomBDropDownItem from "../../common/customBDropDownItem.vue";
import { IDropDownData } from "@/interfaces/common/IDropDown";
import useVuelidate from "@vuelidate/core";
import { helpers, required } from "@vuelidate/validators";
import IconButton from "@/components/common/iconButton.vue";
import CustomMultiSelectSearch from "@/components/common/customMultiSelectSearch.vue";
import { getOrgMembersAddable, posthRoleMembers } from "@/services/org";

import BaseForm from "@/components/common/form/baseForm.vue";
import { IToastMessage, ToastVariant } from "@/interfaces/common/IToastMessage";
import EventEmitter, { EmitterEvents } from "@/utils/eventEmitter";
import { showErrorAPI } from "@/services/apiRoutes";
import { Org } from "@/services/apiRoutes/routes";
import ProgressAnimation from "@/assets/animation/progress_dark.json";
import { LottieAnimation } from "lottie-web-vue";

const DEFAULT_MAX_WIDTH_MODAL = 45;

const cssFieldTitle =
  "tw-border tw-text-[#231F20] tw-text-[13px] tw-leading-none tw-px-[20px] tw-py-[18px] tw-rounded-md tw-border-solid tw-border-[#EFF0F1] tw-bg-[#EFF0F180] tw-max-w-[520px]";

export default /*#__PURE__*/_defineComponent({
  __name: 'addUserRoleModal',
  props: {
  show: {
    type: Boolean,
    required: false,
  },
  roleId: {
    type: String,
    required: true,
  },
  roleName: {
    type: String,
    required: true,
  },
},
  emits: ["update:show", "add:userToRole"],
  setup(__props, { emit }) {

const props = __props;

const grantedOrgsList: Ref<any> = computed(
  () => store.getters["Org/getGrantedOrgs"],
);

const organisationOptions: Ref | IDropDownData[] = ref([]);

const userSelectsCurrentOrg: Ref<any> = computed(
  () => store.getters["Org/getAddableOrgs"],
);

const userSelects: Ref<IDropDownData[]> = ref([]);

const currentOrg = computed(() => store.state.Org.currentOrg);



// Form modal and validation.
let formModel = reactive({
  organisation: [] as IDropDownData[],
  users: [] as IDropDownData[],
});

const rules = {
  organisation: {
    required: helpers.withMessage(
      () => getUiText("app-common-form-value-required-error-1"),
      required,
    ),
  },
  users: {
    required: helpers.withMessage(
      () =>
        getUiText(
          "app-settings-team-roles-add-role-modal-form-error-required-users-1",
        ),
      required,
    ),
  },
};


const formModalOrigin = Object.assign({}, formModel);

let vueValidate;
let showRef = ref(props.show);
let needCheckValidSelectUsers = ref(false);
let customClassInputInvalidRoleTitle = ref(cssFieldTitle);

let isGetUsers = false;
onMounted(() => {
  if (grantedOrgsList.value) setOrgList();
  if (currentOrg.value.id) {
    setAddableOrgs(currentOrg.value.id);
    isGetUsers = true;
  }
}),
  watch(
    () => props.show,
    (value) => {
      showRef.value = value;
      if (value) vueValidate = useVuelidate(rules, formModel);
      onSelectOrgDefault();
    },
  );

const setAddableOrgs = async (orgId: any) => {
  isGetUsers = false;
  try {
    await store.dispatch("Org/fetchAddableOrgList", orgId);
  } catch (error) {
    // Error
  }
};

watch(
  () => userSelectsCurrentOrg.value,
  () => {
    userSelects.value = userSelectsCurrentOrg.value.map((org) => {
      return {
        ...org,
        selected: false,
      };
    });
  },
  { deep: true },
);

const onSelectOrgDefault = () => {
  if (!organisationOptions.value || !organisationOptions.value.length) return;
  const indexOrg = organisationOptions.value.findIndex((org) => {
    return org.id === currentOrg.value.id;
  });
  const indexSelectedOrg = indexOrg > -1 ? indexOrg : 0;
  formModel.organisation = [organisationOptions.value[indexSelectedOrg]];
  userSelects.value = userSelectsCurrentOrg.value.map((org) => {
    return {
      ...org,
      name: org.name,
    };
  });
};

watch(
  () => grantedOrgsList.value,
  () => {
    setOrgList();
  },
  { deep: true },
);

const updateCurrentOrgToList = () => {
  if (!organisationOptions.value.length) pushToList();
  const indexOrg = organisationOptions.value.findIndex((org) => {
    return org.id === currentOrg.value.id;
  });
  if (indexOrg === -1) pushToList();
};

const pushToList = () => {
  if (!currentOrg.value.id) return;
  organisationOptions.value.push({
    id: currentOrg.value.id,
    name: currentOrg.value.nameShort,
    selected: false,
  });
  onSelectOrgDefault();
};
const setOrgList = () => {
  organisationOptions.value = grantedOrgsList.value.map((org) => {
    return {
      ...org,
      id: org.id,
      name: org.name,
      selected: false,
    };
  });
  updateCurrentOrgToList();
};
watch(
  () => currentOrg.value,
  () => {
    if (currentOrg.value.id && !isGetUsers) setAddableOrgs(currentOrg.value.id);
    updateCurrentOrgToList();
  },
  { deep: true },
);

const defaultUiText = computed(() => store.state.LanguagePicker.defaultUiText);
const languageSelectedText = computed(
  () => store.state.LanguagePicker.languageSelectedText,
);

const getUiText = (id: string, isArray = false) => {
  return utilities.getUiText(
    id,
    languageSelectedText.value,
    defaultUiText.value,
    isArray,
  );
};

const handleSelectOrganisation = (item: IDropDownData) => {
  formModel.organisation = [item];
  vueValidate.value.organisation.$touch();
  vueValidate.value.organisation.$model = formModel.organisation;
  getUserOfOrg(item.id);
};
const activeItem = ref(0);
const handleDrop = () => {
  activeItem.value = 0;
};
const moveSelectionDown = (step) => {
  if (organisationOptions.value.length - 1 == activeItem.value) {
    activeItem.value = organisationOptions.value.length - 1;
  } else if (activeItem.value < organisationOptions.value.length) {
    activeItem.value += step;
    const elements = document.getElementsByClassName("show");
    for (let i = 0; i < elements.length; i++) {
      const element = elements[i] as HTMLElement;
      element.scrollTop += 61;
    }
  }
};
const moveSelectionUp = (step) => {
  if (activeItem.value >= 1) {
    activeItem.value += step;
    const elements = document.getElementsByClassName("show");
    for (let i = 0; i < elements.length; i++) {
      const element = elements[i] as HTMLElement;
      element.scrollTop -= 61;
    }
  }
};
const handlEnter = () => {
  const handleData = organisationOptions.value[activeItem.value];
  handleSelectOrganisation(handleData);
};

const getUserOfOrg = async (orgId: any) => {
  try {
    const responseData = await getOrgMembersAddable(orgId);
    if (responseData.data?.data?.length) {
      userSelects.value = responseData.data.data.map((org: any) => {
        return {
          ...org,
          id: org.userId,
          name: `${org.firstName} ${org.lastName}`,
        };
      });
    }
  } catch (error: any) {
    organisationOptions.value = [];
    if (error && error.data) {
      showErrorAPI(error, Org.getAddableOrgMembers);
    }
  }
};

const handleInputUser = (value) => {
  if (needCheckValidSelectUsers.value === false) return;

  formModel.users = value;
  vueValidate.value.users.$touch();
  vueValidate.value.users.$model = formModel.users;
};

const isSubmit = ref(false);

const handleAddUser = async () => {
  if (isSubmit.value) return;
  isSubmit.value = true;

  await vueValidate.value.$validate();
  if (vueValidate.value.$invalid) {
    isSubmit.value = false;
    return;
  }

  try {
    const payload = {
      members: formModel.users.map((user) => user.id),
    };

    await posthRoleMembers(props.roleId, payload);

    const data = {
      users: formModel.users.map((user) => {
        return {
          ...user,
          homeOrgNameShort: formModel.organisation[0].name,
          homeOrgId: formModel.organisation[0].id,
        };
      }),
    };

    isSubmit.value = false;

    const messageSuccess = getComponentUiText(
      "app-settings-team-roles-manage-role-add-user-modal-add-user-toast-message-1",
      false,
      { NumberUser: formModel.users.length.toString() },
    );

    onShowToast(messageSuccess, ToastVariant.SUCCESS);
    handleCloseModal();
    emit("add:userToRole", data);
  } catch (error: any) {
    isSubmit.value = false;
    if (error && error.data) {
      showErrorAPI(error, Org.getMembersOfRole);
    }
  }
};

const onShowToast = (message: string, variant: ToastVariant) => {
  const emitData: IToastMessage = { variant, message };
  EventEmitter.emit(EmitterEvents.APP_LAYOUT_SHOW_TOAST_MESSAGE, emitData);
};

const clearData = () => {
  formModel = reactive(formModalOrigin);
  userSelects.value.forEach((item) => (item.selected = false));
  customClassInputInvalidRoleTitle.value = cssFieldTitle;
  vueValidate.value.$reset();
};

const handleCloseModal = () => {
  clearData();
  showRef.value = false;
  needCheckValidSelectUsers.value = false;
  emit("update:show", showRef.value);
};

return (_ctx: any,_cache: any) => {
  const _component_b_button = _resolveComponent("b-button")!

  return (_openBlock(), _createBlock(Modal, {
    class: "tw-translate-y-[-50%] role-add-user-modal",
    "max-width": DEFAULT_MAX_WIDTH_MODAL,
    visible: _unref(showRef),
    onClose: handleCloseModal
  }, {
    default: _withCtx(() => [
      _createVNode(ModalHeader, {
        class: "modal-header",
        title: 
        _unref(getComponentUiText)(
          'app-settings-team-roles-manage-role-add-user-modal-title-1',
        )
      ,
        onClose: handleCloseModal
      }, null, 8, ["title"]),
      _createVNode(BaseForm, {
        show: _unref(showRef),
        "enter-event": true,
        "onOn:submit": handleAddUser
      }, {
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_1, [
            _createElementVNode("div", _hoisted_2, [
              _createElementVNode("span", _hoisted_3, _toDisplayString(_unref(getComponentUiText)(
                "app-settings-team-roles-manage-role-add-user-modal-sub-title-1",
                false,
                {
                  roleName: props.roleName,
                },
              )), 1),
              _createElementVNode("span", _hoisted_4, _toDisplayString(_unref(getComponentUiText)(
                "app-settings-team-roles-manage-role-add-user-modal-sub-des-1",
              )), 1)
            ]),
            _createElementVNode("div", null, [
              _createElementVNode("div", _hoisted_5, [
                _createElementVNode("span", _hoisted_6, [
                  _createTextVNode(_toDisplayString(getUiText(
                  "app-component-custom-b-dropdown-label-organisation-1",
                )) + " ", 1),
                  _hoisted_7
                ]),
                _createElementVNode("div", _hoisted_8, [
                  _createElementVNode("div", _hoisted_9, [
                    _createVNode(CustomBDropDown, {
                      id: 'dropdownIcon',
                      type: 'single',
                      data: _unref(formModel).organisation,
                      validation: _unref(vueValidate)?.organisation,
                      "class-name": 'gray-dropdown-container tw-h-[58px]',
                      placeholder: 
                    getUiText(
                      'app-component-custom-b-dropdown-prompt-organisation-1',
                    )
                  ,
                      "onUpdate:moveSelectionDown": moveSelectionDown,
                      "onUpdate:showDrop": handleDrop,
                      "onUpdate:enterValue": handlEnter,
                      "onUpdate:moveSelectionUp": moveSelectionUp
                    }, {
                      default: _withCtx(() => [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(organisationOptions.value, (company, index) => {
                          return (_openBlock(), _createBlock(CustomBDropDownItem, {
                            key: company.id,
                            data: company,
                            "class-name": `normal-dropdown-container ${
                      activeItem.value === index ? 'activeItem' : ''
                    }`,
                            onClick: ($event: any) => (handleSelectOrganisation(company))
                          }, null, 8, ["data", "class-name", "onClick"]))
                        }), 128))
                      ]),
                      _: 1
                    }, 8, ["data", "validation", "placeholder"])
                  ])
                ])
              ]),
              _createElementVNode("div", _hoisted_10, [
                _createElementVNode("span", _hoisted_11, [
                  _createTextVNode(_toDisplayString(getUiText("app-component-custom-b-dropdown-label-select-user-1")) + " ", 1),
                  _hoisted_12
                ]),
                _createElementVNode("div", _hoisted_13, [
                  _createElementVNode("div", _hoisted_14, [
                    _createVNode(CustomMultiSelectSearch, {
                      modelValue: _unref(formModel).users,
                      "onUpdate:modelValue": [
                        _cache[0] || (_cache[0] = ($event: any) => ((_unref(formModel).users) = $event)),
                        _cache[1] || (_cache[1] = ($event: any) => (handleInputUser($event)))
                      ],
                      options: userSelects.value,
                      "data-cy-id": "add-user-to-role-modal-select-user",
                      "track-by": "name",
                      label: "name",
                      placeholder: `${getUiText(
                    'app-settings-team-roles-add-role-modal-form-prompt-select-users-1',
                  )}`,
                      "show-check-box": true,
                      validation: _unref(vueValidate)?.users,
                      "onClose:modal": _cache[2] || (_cache[2] = ($event: any) => {
                    _isRef(needCheckValidSelectUsers) //@ts-ignore
 ? needCheckValidSelectUsers.value = true : needCheckValidSelectUsers = true;
                    handleInputUser($event);
                  })
                    }, null, 8, ["modelValue", "options", "placeholder", "validation"])
                  ])
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_15, [
              _createElementVNode("div", _hoisted_16, [
                _createElementVNode("span", _hoisted_17, _toDisplayString(getUiText(
                  "app-settings-team-roles-add-role-modal-form-button-add-user-description-1",
                )), 1),
                _createVNode(IconButton, {
                  class: "tw-bg-[#DBDBDB]",
                  src: "/img/plus_icon.svg"
                })
              ]),
              _createVNode(_component_b_button, {
                type: "submit",
                "data-cy": "add-user-to-role-modal-add-user-button",
                variant: "primary",
                class: "button-verify tw-bg-[#387DFF] tw-h-[39px] tw-py-0 tw-px-[18px] tw-text-[15px] tw-font-medium tw-rounded-[27px]"
              }, {
                default: _withCtx(() => [
                  (isSubmit.value)
                    ? (_openBlock(), _createBlock(_unref(LottieAnimation), {
                        key: 0,
                        class: _normalizeClass('tw-h-[41px] tw-w-full'),
                        "animation-data": _unref(ProgressAnimation),
                        "auto-play": true,
                        loop: true
                      }, null, 8, ["animation-data"]))
                    : _createCommentVNode("", true),
                  _createElementVNode("span", null, _toDisplayString(getUiText("app-settings-team-roles-add-user-button-1")), 1)
                ]),
                _: 1
              })
            ])
          ])
        ]),
        _: 1
      }, 8, ["show"])
    ]),
    _: 1
  }, 8, ["visible"]))
}
}

})